module.exports = "<p>\r\n  exportar-informes works!\r\n</p>\r\n"